import {
  Box,
  Grid,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useLoanStore } from '@roc/feature-loans-shared';
import { Paper } from '@roc/ui';
import { useMemo } from 'react';

const useStyles = makeStyles(theme => ({
  container: {
    padding: '16px',
  },
  label: {
    fontWeight: 400,
    fontSize: '16px',
    letterSpacing: '-0.4px',
    lineHeight: '100%',
    color: '#989898',
    marginBottom: '16px',
  },
  value: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '157%',
    letterSpacing: '0.1px',
  }
}));

const LoanContacts = () => {
  const { loanStore } = useLoanStore();
  const { loanDetails } = loanStore;
  const classes = useStyles();
  const adminSpecialistName = useMemo(() => loanDetails?.drawsAdminSpecialist?.name ?? '', [loanDetails]);
  const reviewSpecialistName = useMemo(() => loanDetails?.drawsReviewSpecialist?.name ?? '', [loanDetails]);

  return (
    <Grid item>
      <Paper title="Loan Contacts">
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <Grid container direction="row" spacing={2} className={classes.container}>
              <Grid item xs={6} md={6}>
                <Typography variant="body1" className={classes.label}>
                  Admin Specialist:
                </Typography>
                <Typography variant="body2" className={classes.value}>
                  {adminSpecialistName}
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="body1" className={classes.label}>
                  Review Specialist:
                </Typography>
                <Typography variant="body2" className={classes.value}>
                  {reviewSpecialistName}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default LoanContacts;
